import React from "react";

// Same visual as PayStep's inline payment-method cards - shared here since
// FormTypeStep/AmendedReturnStep need the identical radio-card pattern.
const OptionCard = ({ title, subtitle, selected, onClick, disabled = false }) => (
  <div
    onClick={disabled ? undefined : onClick}
    className={[
      "flex gap-3 items-start border rounded-[var(--r-sm)] p-3.5",
      disabled ? "opacity-60 cursor-not-allowed" : "cursor-pointer",
      selected ? "border-[var(--accent)] bg-[var(--accent-soft)]" : "border-[var(--line-2)]",
    ].join(" ")}
  >
    <span
      className={[
        "w-[18px] h-[18px] rounded-full border-2 flex-none mt-0.5",
        selected ? "border-[var(--accent)]" : "border-[var(--line-2)]",
      ].join(" ")}
      style={
        selected ? { background: "radial-gradient(circle, var(--accent) 0 5px, transparent 6px)" } : undefined
      }
    />
    <span>
      <b className="font-semibold">{title}</b>
      {subtitle && <small className="block text-[var(--muted)] text-[12.5px]">{subtitle}</small>}
    </span>
  </div>
);

export default OptionCard;
